"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.excludeHealthProbesTelemetryProcessor = void 0;
const excludeHealthProbesTelemetryProcessor = ({
  data
}) => {
  if (data.baseType === 'RequestData' && data.baseData?.name?.startsWith('GET /health/')) {
    return false;
  }
  if (data.baseType === 'RemoteDependencyData' && data.baseData?.properties?.url?.startsWith('/health/')) {
    return false;
  }
  return true;
};
exports.excludeHealthProbesTelemetryProcessor = excludeHealthProbesTelemetryProcessor;
